// extracted by mini-css-extract-plugin
export default {"policy_block":"PrivacyPolicy_policy_block__Jqjv+"};